import {
    ACTION_RESET_NFT_MANAGER_STORE,
    ACTION_SET_MANAGER_SEARCH_VALUE,
    ACTION_UPDATE_MANAGER_NFT_FILTERS,
    type NFTManagerActions,
    type NFTManagerState,
} from '../types/nft-manager';

const DEFAULT: NFTManagerState = {
    managerSearchValue: '',
    managerFilters: {},
};

export function nftManager(state: NFTManagerState = DEFAULT, action: NFTManagerActions): NFTManagerState {
    switch (action.type) {
        case ACTION_RESET_NFT_MANAGER_STORE:
            return DEFAULT;

        case ACTION_SET_MANAGER_SEARCH_VALUE:
            return { ...state, managerSearchValue: action.managerSearchValue };

        case ACTION_UPDATE_MANAGER_NFT_FILTERS: {
            const managerFilterData = { ...state.managerFilters };

            if (action.clear) {
                return { ...state, managerFilters: {} };
            }

            return {
                ...state,
                managerFilters: {
                    ...managerFilterData,
                    ...action.filter,
                },
            };
        }

        default:
            return state;
    }
}
